import { useSwr } from "hooks/atPort/useSwr";
import { formatQueryParams } from "utils/stringUtils";

export const useFindUsers = ({
  searchKeyword,
  after,
  before,
  first,
  last,
  searchTarget,
}: {
  searchKeyword: string;
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  searchTarget?: "accountId" | "contactId" | "companyName" | "email";
}) => {
  const { data, error, mutate } = useSwr<LesseeUsers>(
    `/user?${formatQueryParams({
      search: searchKeyword,
      searchTarget,
      after,
      before,
      first,
      last,
    })}`
  );

  return {
    data: data?.data,
    pagination: data?.pagination,
    error,
    mutate,
  };
};
